import React from 'react';
import { Lock } from 'lucide-react';

/**
 * Renders KioskApp only when running inside the Piczoo booth Electron shell
 * (i.e. when `window.piczooKiosk` is present, exposed by preload.js).
 *
 * Browser visitors hitting /kiosk or /kiosk/:id directly see a sealed page.
 */
const BoothOnly = ({ children }) => {
  const isBooth = typeof window !== 'undefined' && !!window.piczooKiosk;

  if (isBooth) return children;

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-charcoal-900 text-cream-50 p-8"
      data-testid="booth-only-gate"
    >
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mx-auto mb-6">
          <Lock className="w-7 h-7 text-cream-50/70" />
        </div>
        <h1 className="font-serif text-3xl mb-3">Booth Software Only</h1>
        <p className="text-sm text-cream-50/60 leading-relaxed">
          This screen runs inside the Piczoo Booth Software on a paired photobooth machine.
          It cannot be opened in a regular browser.
        </p>
        <a
          href="/"
          className="inline-block mt-8 text-xs uppercase tracking-[0.2em] text-cream-50/40 hover:text-cream-50/70 transition-colors"
        >
          ← Back to piczoo.in
        </a>
      </div>
    </div>
  );
};

export default BoothOnly;
